var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.73667,0,0,0.755314,0,-1.04316e-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.867,0C30.387,0 0,30.387 0,67.875C0,97.862 19.446,123.3 46.417,132.279C49.813,132.9 51.05,130.804 51.05,129.004C51.05,127.396 50.992,123.125 50.958,117.463C32.079,121.563 28.096,108.363 28.096,108.363C25.008,100.525 20.558,98.437 20.558,98.437C14.396,94.225 21.025,94.308 21.025,94.308C27.838,94.792 31.421,101.304 31.421,101.304C37.475,111.675 47.308,108.679 51.175,106.946C51.792,102.558 53.542,99.567 55.483,97.871C40.413,96.158 24.567,90.333 24.567,64.325C24.567,56.917 27.213,50.858 31.554,46.113C30.854,44.396 28.525,37.496 32.217,28.15C32.217,28.15 37.917,26.325 50.883,35.108C56.296,33.604 62.104,32.85 67.875,32.825C73.638,32.85 79.446,33.604 84.867,35.108C97.825,26.325 103.513,28.15 103.513,28.15C107.217,37.496 104.888,44.396 104.187,46.113C108.537,50.858 111.167,56.917 111.167,64.325C111.167,90.4 95.296,96.138 80.175,97.817C82.613,99.913 84.783,104.054 84.783,110.388C84.783,119.458 84.7,126.779 84.7,129.004C84.7,130.821 85.921,132.933 89.367,132.271C116.317,123.275 135.746,97.854 135.746,67.875C135.746,30.388 105.354,-0 67.867,-0",
    style: {
      fill: "rgb(38,166,154)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.59c01982000b66d6347a744d34f33206.svg";
export { ForwardRef as ReactComponent };